import { render, staticRenderFns } from "./Accomplishment.vue?vue&type=template&id=80742134&scoped=true&"
import script from "./Accomplishment.vue?vue&type=script&lang=js&"
export * from "./Accomplishment.vue?vue&type=script&lang=js&"
import style0 from "./Accomplishment.vue?vue&type=style&index=0&id=80742134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80742134",
  null
  
)

export default component.exports